import React, {Component} from 'react';
import PropTypes from "prop-types";

class CheckBoxField extends Component {

    static propTypes = {
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        label: '',
        value: null,
        isChecked: false,
    };

    constructor(props) {

        super(props);

        this.state = {
            isChecked: props.isChecked,
        };

        this.onChange = this.onChange.bind(this);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.isChecked !== this.props.isChecked) {
            this.setState({
                isChecked: nextProps.isChecked,
            });
        }

    }

    onChange() {

        const isChecked = !this.state.isChecked;

        this.setState({isChecked : isChecked});

        this.props.onChange(this.props.name, isChecked);

    }

    render() {

        const {isRequired, isChecked, ...inputProps} = {...this.props};
        const classes = ['checkLabel', ((this.state.isChecked) ? 'isChecked' : '')].join(' ').trim();
        const value = (this.props.value) ? this.props.value : this.props.name;

        return (
            <label className={classes}>
                <input {...inputProps}
                       type="checkbox"
                       value={value}
                       tabIndex="-1"
                       checked={this.state.isChecked}
                       onChange={() => {this.onChange()}}
                />

                <i>i</i>

                <span>{this.props.label}</span>
            </label>
        );

    }

}

export default CheckBoxField;